import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import {
  ContactsListContainer,
  HeaderWrapper,
  Title,
} from "./RelatedContactList.styled";

import "./RelatedContactList.scss";
import AddEditRelatedContact from "../AddEditRelatedContact/AddEditRelatedContact";

/**
 * Related Contact List,
 * Path - /relatedContacts
 * @see See [RelatedContact Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2914615301/Related+contacts+-+List)
 * @component
 */
const RelatedContactList = (props) => {
  const {
    t,
    columnList,
    entityId,
    entityType,
    companyId,
    parents,
    headerNotRequired,
    dependancies,
    countryId,
  } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [isAddRelatedContactPopupVisible, setAddRelatedContactPopupVisible] =
    useState(false);

  const createRelatedContact = () => {
    setAddRelatedContactPopupVisible(true);
  };

  const closeRelatedContactCreationPopup = () => {
    setAddRelatedContactPopupVisible(false);
  };

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <ContactsListContainer
      className="contact-notes-list"
      marginTop={headerNotRequired ? "0px" : "30px"}
    >
      {!headerNotRequired && (
        <HeaderWrapper>
          <Title>{t("CONTACTS")}</Title>
        </HeaderWrapper>
      )}
      <PrepareDataTable
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        columnList={columnList}
        entityType={entityType}
        entityId={entityId}
        createRelatedContact={createRelatedContact}
        dependancies={dependancies}
        countryId={countryId}
      />
      {isAddRelatedContactPopupVisible && (
        <AddEditRelatedContact
          title={t("RELATED_CONTACT")}
          onClose={closeRelatedContactCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          companyId={companyId}
          parents={parents}
          entityType={entityType}
          entityId={entityId}
          countryId={countryId}
          dependancies={JSON.stringify(["roles"])}
        />
      )}
    </ContactsListContainer>
  );
};

RelatedContactList.propTypes = {
  t: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  parents: PropTypes.bool,
  headerNotRequired: PropTypes.bool,
  dependancies: PropTypes.string,
  countryId: PropTypes.number,
};

RelatedContactList.defaultProps = {
  companyId: null,
  parents: false,
  dependancies: "",
  headerNotRequired: false,
  countryId: null,
};

export default withTranslation()(RelatedContactList);
